module.exports = __webpack_public_path__ + "static/media/light-theme-max-RPM.e655f794.svg";